const transformLocation = (v) => {
	const { location, seoLocation } = v;
	return {
		...location,
		preferredPlaceName: seoLocation?.city || location?.subLocality || location?.city
	};
};

export const getDisplayCityName = (cityName) =>
	cityName?.toLowerCase() === 'washington' ? 'Washington, D.C.' : cityName;

export default transformLocation;
